import * as React from "react";
import ReactDOM from 'react-dom';
import { ToastContainer, toast, ToastOptions } from "react-toastify";

let hasContainer = false;

export default function (content: string | JSX.Element, options: ToastOptions) {
  if (!hasContainer) {
    hasContainer = true;
    ReactDOM.render(<ToastContainer newestOnTop={true} />, document.getElementById('root-toastify'));
  }
  toast(content, options);
}
  